/* ==========================================================================
   ASJ CUSTOM - Places the "Shop by Category" collection list into the native
   collection filter sidebar (desktop) and the native mobile filter drawer.
   It only MOVES a server-rendered list of real collection links (from the
   Shopify menu "shop-by-category") into Dawn's native filter containers; it
   does not filter anything in JS - clicking a category is a normal navigation
   to a real Shopify collection. Re-injects after Dawn's AJAX facet re-renders.
   Safe to remove. ========================================================== */
(function () {
  'use strict';

  function template() { return document.getElementById('asj-cat-template'); }

  function injectInto(container) {
    if (!container || container.querySelector('.asj-cat')) return;
    var tpl = template();
    if (!tpl || !tpl.content) return;
    container.insertBefore(tpl.content.cloneNode(true), container.firstChild);
  }

  function run() {
    if (!template()) return;
    var side = document.getElementById('main-collection-filters');
    if (side) injectInto(side.querySelector('.facets__form-vertical') || side);
    injectInto(document.querySelector('#FacetFiltersFormMobile .mobile-facets__main'));
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }

  function boot() {
    run();
    var root = document.querySelector('collection-component') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();